import { IFilterFormContent, MarketSortingTypes } from '@dev-fast/types';

export class GetSteamInventory {
  static readonly type = '[p2p] Get Steam Inventory';
  constructor(public params?: IFilterFormContent<MarketSortingTypes>) {}
}
export class GetSteamStatus {
  static readonly type = '[p2p] Get Steam Status';
}
